module.exports = {
  API_URL: '//api.clients.qc.viralstyle.com',
  API_ROOT: '',
  APP_PROTOCOL: 'https',
  APP_URL: 'qc.viralstyle.com',
  APP_DOMAIN: 'viralstyle.com',
  ENVIRONMENT: 'Staging',
  PRIMARY_COLOR: '#00B398',
  ERROR_COLOR: '#da625a',
  RAVEN_URL: 'https://0c6c393cbdb847ba9caa50f6e86c50f9@sentry.io/1356281',
  INTERCOM_ID: 'waacz34n',
  GTM_ID: 'GTM-W3FBMRS',
  GOOGLE_RECAPTCHA_SITEKEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  PLUS_URL: 'https://beta.plus.viralstyle.com/load',
  CUSTOMER_API_URL: 'https://api.customers.qc.viralstyle.com/api/v3',
  PINGPONG_REDIRECT: 'https://clients.qc.viralstyle.com/settings/',
  PINGPONG_ENABLED: false,
  CDN: '/',
  WHITELABEL_IP: '34.194.93.2',
};
